/** @jsx jsx */
import { useState, Fragment, useRef, useEffect } from 'react'
import { css, jsx, keyframes } from '@emotion/core'
import {
  Button,
  Input,
  RadioButton,
  CheckboxField,
} from '@livechat/design-system'
import validator from 'validator'

import checkIcon from '../../assets/images/check.png'
import binIcon from '../../assets/images/bin.png'
import { TYPES } from '../../constants'

const { SINGLE_CHOICE } = TYPES

const answerAnimation = keyframes`
 from {
    transform: translateY(10px);
 }
`

const answerCss = (isTemplate) => css`
  ${!isTemplate &&
  css`
    animation: ${answerAnimation} 0.1s linear;
  `}

  .edit-answer {
    display: flex;
    align-items: center;
  }

  .answer-check {
    margin-right: 8px;

    > div {
      width: 16px;
    }

    > div > img {
      width: 16px;
    }
  }

  .answer-drop {
    > div {
      width: 16px;
    }

    > div > img {
      width: 16px;
    }
  }
`

const Answer = ({
  isDraft,
  type,
  answer,
  onChange,
  handleEdit,
  handleSubmit,
  handleDrop,
  isTemplate,
}) => {
  const [error, setError] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    if (isDraft && inputRef) {
      inputRef.current.select()
    }
  }, [isDraft])

  const onSubmit = () => {
    if (answer && !validator.isEmpty(answer, { ignore_whitespace: true })) {
      if (answer.length < 100) {
        setError('')
        handleSubmit()
      } else {
        setError('Answer is to long.')
      }
    } else {
      setError('Answer cannot be empty.')
    }
  }

  return (
    <Fragment>
      <div css={answerCss(isTemplate)}>
        {isDraft ? (
          <div className="edit-answer">
            <Input
              value={answer}
              error={error || undefined}
              onChange={onChange}
              ref={inputRef}
            />
            <Button className="answer-check" type="ghost" onClick={onSubmit}>
              <img src={checkIcon} alt="check" draggable="false" />
            </Button>
            <Button className="answer-drop" type="ghost" onClick={handleDrop}>
              <img src={binIcon} alt="drop" draggable="false" />
            </Button>
          </div>
        ) : type === SINGLE_CHOICE ? (
          <RadioButton checked={false} onClick={handleEdit}>
            {answer}
          </RadioButton>
        ) : (
          <CheckboxField checked={false} onClick={handleEdit}>
            {answer}
          </CheckboxField>
        )}
      </div>
      {error && (
        <span className="error" style={{ marginBottom: '5px' }}>
          {error}
        </span>
      )}
    </Fragment>
  )
}

export default Answer
